<template>
  <div>
    <!--<CPortada :pseccion="pseccion"></CPortada>-->

    <Cbarra>
        <template slot="slotTitle">{{tip.Titulo}}</template>
        <template slot="slotRoute">
            <router-link :to="{name:'index'}">Inicio</router-link> / <a href="#">Nosotros</a> / <router-link :to="{name:'organigrama'}">Organigrama</router-link>
        </template>
    </Cbarra>

    <div class="container justify-content-center">
        <div class="bg-principal-02">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <img :src="Img" class="w-100" alt="ENES">
                </div>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
export default {
    name:'',
    data() {
        return {
            pseccion:'Organigrama',
            Img: null,
			RutaFile: "",
			NameFile: "",
			tip: {
				Titulo: "",
				Imagen: "",
				IdSeccion: 0
			},
			urlApi: "nostros/organigrama",
        }
    },methods: {
        	get_one() {
			this.$http
				.get(this.urlApi, {
					params: {Seccion:"organigrama" }
				})
				.then(res => {
					this.tip = res.data.data.secciones;
					this.Img = res.data.RutaFile + this.tip.Imagen;
					//this.Img = res.data.RutaFile + res.data.data.tip.Imagen;
				});
		},
    },created() {
        this.get_one();
    },
}
</script>

<style>

</style>